import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'

import { sortByKey, sortByDateKey } from '../../util/sorting'
import { Divider } from '../styles/Containers'
import {
  CondensedTable,
  HeaderRow,
  HeaderButton,
  TemplateNameColumn,
  TemplateDateColumn,
  TemplateActionContainer,
  UnfoldMoreIconRight,
  EmptyText
} from '../styles/TableStyles'
import CommunicationTemplateRow from './CommunicationTemplateRow'

const SORT_KEYS = {
  name: sortByKey('name'),
  updatedAt: sortByDateKey('updatedAt')
}

function CommunicationTemplateTable({ communicationTemplates, onEditCommunicationTemplate = () => {}, handleSelectTemplate = () => {} }) {
  const [sortBy, setSortBy] = useState('updatedAt')
  const [sortedTemplates, setSortedTemplates] = useState([])
  const [sortAscending, setSortAscending] = useState(true)

  function sort(key) {
    if (key === sortBy) {
      setSortedTemplates(prev => [...prev].reverse())
      setSortAscending(prev => !prev)
    } else {
      setSortBy(key)
      setSortAscending(true)
      setSortedTemplates(prev => [...prev].sort(SORT_KEYS[key]))
    }
  }

  useEffect(() => {
    if (communicationTemplates && communicationTemplates.length > 0) {
      const comparator = SORT_KEYS[sortBy]
      let next = [...communicationTemplates].sort(comparator)
      if (!sortAscending) next = next.reverse()
      setSortedTemplates(next)
    } else {
      setSortedTemplates([])
    }
  }, [communicationTemplates])

  return (
    <CondensedTable>
      <HeaderRow>
        <TemplateNameColumn>
          <HeaderButton variant="text" onClick={() => sort('name')} active={(sortBy === 'name').toString()}>
            Subject <UnfoldMoreIcon />
          </HeaderButton>
        </TemplateNameColumn>
        <TemplateDateColumn>
          <HeaderButton variant="text" onClick={() => sort('updatedAt')} active={(sortBy === 'updatedAt').toString()}>
            Last Modified <UnfoldMoreIconRight />
          </HeaderButton>
        </TemplateDateColumn>
        <TemplateActionContainer />
      </HeaderRow>
      <Divider />
      {sortedTemplates && sortedTemplates.length > 0 ? (
        sortedTemplates.map(communicationTemplate => (
          <React.Fragment key={communicationTemplate.id}>
            <CommunicationTemplateRow
              communicationTemplate={communicationTemplate}
              onEditCommunicationTemplate={onEditCommunicationTemplate}
              handleSelectTemplate={handleSelectTemplate}
            />
            <Divider />
          </React.Fragment>
        ))
      ) : (
        <EmptyText>No communication templates available</EmptyText>
      )}
    </CondensedTable>
  )
}

CommunicationTemplateTable.propTypes = {
  communicationTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      updatedAt: PropTypes.instanceOf(Date).isRequired
    })
  ).isRequired,
  onEditCommunicationTemplate: PropTypes.func,
  handleSelectTemplate: PropTypes.func
}

export default CommunicationTemplateTable
